<div class="flex flex-row">
    <div class="flex-col text-center bg-secondary-tselCard rounded-md p-1 mr-1">
      <div class="font-telkomsel-batik-bold text-mobile-h4 md:text-desktop-h6 text-primary-darkBlue px-2">
        {{days}}
      </div>
      <div class="font-poppins-regular text-f-10 md:text-mobile-body-small text-primary-darkBlue px-2">hari
      </div>
    </div>
    <div class="flex-col text-center bg-secondary-tselCard rounded-md p-1 mr-1">
      <div class="font-telkomsel-batik-bold text-mobile-h4 md:text-desktop-h6 text-primary-darkBlue px-2">
        {{hours}}
      </div>
      <div class="font-poppins-regular text-f-10 md:text-mobile-body-small text-primary-darkBlue px-2">jam
      </div>
    </div>
    <div class="flex-col text-center bg-secondary-tselCard rounded-md p-1 mr-1">
      <div class="font-telkomsel-batik-bold text-mobile-h4 md:text-desktop-h6 text-primary-darkBlue px-2">
        {{minutes}}
      </div>
      <div class="font-poppins-regular text-f-10 md:text-mobile-body-small text-primary-darkBlue px-2">menit
      </div>
    </div>
    <div class="flex-col text-center bg-secondary-tselCard rounded-md p-1">
      <div class="font-telkomsel-batik-bold text-mobile-h4 md:text-desktop-h6 text-primary-darkBlue px-2">
        {{seconds}}
      </div>
      <div class="font-poppins-regular text-f-10 md:text-mobile-body-small text-primary-darkBlue px-2">detik
      </div>
    </div>
  </div>